import Vue from 'vue'
import Router from 'vue-router'
import CategorySelection from './views/CategorySelection'
import Favourites from './views/Favourites'
import Live from './views/Live.vue'
import LiveLivingOption from './views/LiveLivingOption'
import LivePackages from './views/LivePackages'
import LiveDwellings from './views/LiveDwellings'
import Page from './views/Page.vue'
import Rest from './views/Rest.vue'
import { bus } from './main'
import store from './store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      name: 'rest',
      path: '/',
      component: Rest
    },
    {
      name: 'category-selection',
      path: '/select',
      component: CategorySelection
    },
    {
      name: 'favourites',
      path: '/category/:categoryId/favourites',
      component: Favourites
    },
    {
      name: 'favourite-modal',
      path: '/category/:categoryId/favourites/:favouriteId',
      component: Favourites
    },
    {
      name: 'page',
      path: '/category/:categoryId/page/:pageId',
      component: Page
    },
    {
      name: 'live',
      path: '/category/:categoryId/live',
      component: Live
    },
    {
      name: 'live-display-homes',
      path: '/category/:categoryId/live/display-homes',
      component: Live
    },
    {
      name: 'live-display-homes-property',
      path: '/category/:categoryId/live/display-homes/property/:propertyId',
      component: Live
    },    

    {
      name: 'live-page',
      path: '/live/page/:pageId',
      component: Page
    },
    {
      name: 'packages',
      path: '/category/:categoryId/live/packages',
      component: LivePackages
    },
    {
      name: 'package-modal',
      path: '/category/:categoryId/live/packages/:packageId',
      component: LivePackages
    },
    {
      name: 'dwellings',
      path: '/category/:categoryId/live/dwellings',
      component: LiveDwellings
    },
    {
      name: 'dwelling-modal',
      path: '/category/:categoryId/live/dwellings/:dwellingId',
      component: LiveDwellings
    },
    {
      name: 'turnkeys',
      path: '/category/:categoryId/live/turnkeys',
      component: LiveDwellings
    },
    {
      name: 'turnkey-modal',
      path: '/category/:categoryId/live/turnkeys/:propertyId',
      component: Page
    },
    {
      name: 'living-entry',
      path: '/category/:categoryId/live/:pathway',
      component: Page
    },
    {
      name: 'living-option',
      path: '/category/:categoryId/live/:pathway/:livingOptionId',
      component: LiveLivingOption
    },
    {
      name: 'subsection',
      path: '/category/:categoryId/live/:pathway/:livingOptionId/subsection/:subsectionId',
      component: Page
    },
    {
      name: 'property',
      path: '/category/:categoryId/live/:pathway/:livingOptionId/subsection/:subsectionId/property/:propertyId',
      component: Page
    }
  ]
})

// TODO: route guard bottombar visiblilty - is there a better way of doing this?
// TODO: handle skipping category selection better
router.beforeEach((to, from, next) => {
  if (to.path === '/select') {
    if (store.getters.navigation && store.getters.navigation.length === 1) {
      store.state.isBottomBarVisible = true
      const category = store.getters.navigation[0]
      const defaultChildUrl = store.getters.navigation[0].defaultChildUrl
      const isCustomRoute = store.getters.navigation[0].isCustomRoute
      const customRoute = store.getters.navigation[0].customRoute
      
      let newTo = ''

      if (isCustomRoute) {
        newTo = customRoute
      } else if (defaultChildUrl) {
        newTo = defaultChildUrl
      } else {
        newTo = `/category/${category._id}/page/${category.children[0].pageId}`
      }
      
      if (from.path === newTo) {
        next(false)
      } else {
        next(newTo)
      }
    } else {
      store.state.isBottomBarVisible = false    
      next()
    }
  } else if (['/'].includes(to.path)) {
    store.state.isBottomBarVisible = false     
    next()
  } else {
    store.state.isBottomBarVisible = true
    next()
  }
})

router.afterEach(() => {
  // store.commit('clearAnimationQueue')

  setTimeout(() => {
    bus.$emit('startAnimations')
  }, 100)
})

export default router
